import React, { useEffect, useState } from 'react';

import ModalPortal from '../components/modal-portal';

export interface TiebreakStepView {
  label: string;
  description: string;
  primary: boolean;
}

interface Props {
  hint?: string;
  steps?: TiebreakStepView[];
  // Jak punktowane są sety w tej grupie — zdanie gotowe, tak jak w panelu.
  formatLabel?: string | null;
  testId?: string;
}

// Kolejność, którą stoi tabela, musi być do sprawdzenia BEZ najeżdżania myszą —
// wyniki czyta się przy korcie, z telefonu, gdzie tooltipa nie ma jak wywołać.
// Chip daje tooltip na hover, a kliknięty otwiera okno z pełnym wyjaśnieniem.
export const TiebreakNote: React.FC<Props> = ({
  hint,
  steps,
  formatLabel = null,
  testId = 'tiebreak-note',
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      return;
    }

    function onKeyDown(event: KeyboardEvent): void {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    }

    document.addEventListener('keydown', onKeyDown);

    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);

  if (!hint) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="tiebreak-note__toggle"
        data-testid={`${testId}-toggle`}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label="Jak liczymy tę tabelę"
        title={hint}
        onClick={() => setOpen(true)}
      >
        <span aria-hidden>i</span>
      </button>

      {open && (
        <ModalPortal>
          <div
            className="tiebreak-modal__backdrop"
            data-testid={`${testId}-modal`}
            onClick={() => setOpen(false)}
          >
            <div
              role="dialog"
              aria-modal="true"
              aria-label="Jak liczymy tę tabelę"
              className="tiebreak-modal"
              onClick={(event) => event.stopPropagation()}
            >
              <header className="tiebreak-modal__head">
                <h3 className="tiebreak-modal__title">Jak liczymy tę tabelę</h3>
                <button
                  type="button"
                  className="tiebreak-modal__close"
                  data-testid={`${testId}-close`}
                  aria-label="Zamknij"
                  onClick={() => setOpen(false)}
                >
                  ✕
                </button>
              </header>

              {formatLabel && (
                <section className="tiebreak-modal__section" data-testid={`${testId}-scoring`}>
                  <h4 className="tiebreak-modal__subtitle">Punktacja</h4>
                  <p className="tiebreak-modal__line">{formatLabel}</p>
                </section>
              )}

              <section className="tiebreak-modal__section">
                <h4 className="tiebreak-modal__subtitle">Kolejność</h4>
                {steps && steps.length > 0 ? (
                  <ol className="tiebreak-modal__steps" data-testid={`${testId}-steps`}>
                    {steps.map((step, index) => (
                      <li key={step.label} className="tiebreak-modal__step">
                        <span className="tiebreak-modal__ordinal">{index + 1}</span>
                        <span>
                          <strong className="tiebreak-modal__label">
                            {step.label}
                            {step.primary && (
                              <span className="tiebreak-modal__badge">klucz główny</span>
                            )}
                          </strong>
                          <span className="tiebreak-modal__desc">{step.description}</span>
                        </span>
                      </li>
                    ))}
                  </ol>
                ) : (
                  <p className="tiebreak-modal__line">{hint}</p>
                )}
                <p className="tiebreak-modal__foot">
                  Równi na wszystkich kryteriach dzielą miejsce — i te same punkty za miejsce w
                  klasyfikacji sezonu.
                </p>
              </section>
            </div>
          </div>
        </ModalPortal>
      )}
    </>
  );
};

export default TiebreakNote;
